import {ReactElement} from "react";
import {useTranslation} from "next-i18next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Layout from "../components/common/Layout";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import GoodsSelector from "../components/Goods/GoodsSelector";
import {HeaderVermietung} from "../data/StaticImages";
import {getSafeLocale} from "../helpers/LocalizeObject";

export default function GoodsPage() {
	const {t} = useTranslation();

	return (
		<>
			<HeaderImageWithHeading imageSrc={HeaderVermietung} title={t("pages.goods.title")} subtitle={t("pages.goods.subtitle")}/>
			<main className="mx-auto max-w-[1440px] px-5 py-12 md:px-14">
				<GoodsSelector showBookingIdApply/>
			</main>
		</>
	);
}

export async function getStaticProps({locale}: { locale?: string }) {
	return {
		props: {
			...(await serverSideTranslations(getSafeLocale(locale), ["common"]))
		}
	};
}

GoodsPage.getLayout = function getLayout(page: ReactElement) {
	return <Layout headerNotTransparent={true} color="#000000">{page}</Layout>;
};
